<template>
  <div :class="`m-portal m-portal-${routeType}-main`">
    <portal-nav-top></portal-nav-top>
    <div id="ljh-culture">
      <div class="container-fluid" style="width:1100px;">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-cult-nav></portal-cult-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page">
              <div class="navigation">
                <span>首页</span>
                <span>></span>
                <span>朱子文化</span>
                <span>></span>
                <span>文化内涵</span>
              </div>
              <div class="article">
                <bs-detail :meta="{ module:'culture', field:'zzwh' }">
                  <template slot="data" slot-scope="slot">
                    <content v-html="slot.data.remark"></content>
                  </template>
                  <template slot="empty">
                    <div class="list-none">
                      <ul></ul>
                    </div>
                  </template>
                </bs-detail>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <portal-footer></portal-footer>
  </div>
</template>

<script>
require("../../styles/portal/culture.scss");
export default {
  data() {
    return { routeType: "cult" };
  },
  components: {
    PortalFooter: () => import("./portal-footer"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalCultNav: () => import("./portal-cult-nav"),
    BsDetail: () => import("../../components/bs-detail")
  },
  methods: {},
  created() {
    //this.$menuFn.setTitle("portal-from-detail");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-cult-main") {
        //this.$menuFn.setTitle("portal-from-detail");
      }
    }
  }
};
</script>

<style scoped>
</style>